<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Add Question
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              :error-messages="messages.question"
              v-model="question.question"
              label="Question"
              type="text"
            ></v-text-field>
            <h3>Answers</h3>
            <v-text-field
              :error-messages="messages.a"
              v-model="question.a"
              label="Answer A"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.b"
              v-model="question.b"
              label="Answer B"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.c"
              v-model="question.c"
              label="Answer C"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.d"
              v-model="question.d"
              label="Answer D"
              type="text"
            ></v-text-field>
            <h3>Please select the correct answer</h3>
            <v-btn-toggle
              v-model="question.correct_answer"
              :error-messages="messages.correct_answer"
            >
              <v-btn v-if="question.a" value="a">A</v-btn>
              <v-btn v-if="question.b" value="b">B</v-btn>
              <v-btn v-if="question.c" value="c">C</v-btn>
              <v-btn v-if="question.d" value="d">D</v-btn>
            </v-btn-toggle>
            <p v-if="messages.correct_answer" class="pt-5"><span style="color:red;">Select a correct Answer</span></p>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="primary" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-2" @click="addQuestion">Add Question</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import testAPI from "@/api/test.js";
export default {
  name: "CreateTest",
  components: {},
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      question: {},
      answers: {},
      messages: {},
      loading: false,
      successMessage: "Question has been added",
      errorMessage: "Oops something went wrong",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    addQuestion() {
      this.loading = true;
      testAPI
        .createQuestion(this.question, this.id)
        .then(() => {
          this.closePanel();
          EventBus.$emit("QUESTIONS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
